"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehiclesSearchQuery = void 0;
exports.vehiclesSearchQuery = `
  query VehicleSearch(
    $paths: [String!]
    $searchTerm: String = null
    $pageSize: Int = 100
    $includeTopicNames: [String!] = []
    $excludeTopicNames: [String!] = []
    $cursor: String = null
  ) {
    search(
      language: "no"
      filter: {
        type: PRODUCT
        include: {
          shapeIdentifiers: "trim"
          paths: $paths
          topicNames: $includeTopicNames
        }
        exclude: { topicNames: $excludeTopicNames }
        searchTerm: $searchTerm
      }
      first: $pageSize
      after: $cursor
      orderBy: { field: ITEM_NAME, direction: ASC }
    ) {
      aggregations {
        totalResults
      }
      pageInfo {
        startCursor
      }
      edges {
        node {
          path
          ... on Product {
            matchingVariant {
              sku
            }
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=vehicle-search.js.map